import { styled } from '../mui';

export const SweepTextWrap = styled('pre')`
  overflow-y: auto;
  max-height: 100%;
  white-space: inherit;
`;

export const Popup = styled('div')`
  background: #fff;
  height: 90%;
  width: 90%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 111;
  right: 0;
  bottom: 0;
  margin: auto;
  border-radius: 8px;

  .close {
    position: absolute;
    float: none;
    top: 15px;
    right: 15px;
    padding: 0;
    opacity: 1;
    font-size: 14px;
    cursor: pointer;
    background: #fff;
    border-radius: 50%;
    height: 30px;
    width: 30px;
    text-align: center;

    &:hover {
      svg,
      i {
        color: var(--color-secondary);
      }
    }

    svg,
    i {
      color: #aaa;
      font-size: 20px;
      transition: all 0.3s ease;
    }
  }

  h2 {
    font-size: 1.4em;
    padding: 20px 0;
    text-align: center;
  }

  .square-button {
    margin-top: 20px;
    text-align: center;
  }

  input {
    border-bottom: 1px solid #ccc;
  }

  iframe {
    height: 100% !important;
    width: 100% !important;
    position: relative;
    top: 0;
    left: 0;
    border-radius: 8px;
  }

  &.rtl {
    text-align: right;

    input {
      text-align: right;
    }
  }
`;

export const SweepPopup = styled('div')`
position: $position;
right: 0;
left: 0;
top: 0;
bottom: 0;
margin: auto;
display: block;
z-index: 111;
padding: 20px;
max-width: 100vw !important;
max-height: 100vh !important;

.fa-times {
  top: -10px;
  right: -10px;
}

&.text {
  background: rgba(0, 0, 0, 0.5);
  text-align: center;
  color: #fff;
  height: 40px;
  line-height: 40px;
  width: 400px;
  font-size: 16px;
  padding: 0;

  pre {
    white-space: break-spaces;
    text-align: justify;
    color: #fff;
    padding: 1rem;
  }
}

&.image {
  height: 500px;
  width: 600px;
  max-width: 100vw;
  max-height: 100vh;
  background: #fff;

  &.s {
    height: 400px;
  }

  .img {
    height: 100%;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    display: block;
  }
}

&.video,
&.iframe {
  height: 400px;
  width: 600px;

  iframe {
    height: 100%;
    width: 100%;
    background-color: #f8f8f8;
  }

}

&.iframe {
  width: 1500px;
  height: 600px;
}

&.green-screen {
  background: transparent;

  &.left {
    right: auto;
  }

  &.right {
    left: auto;

    .close {
      left: -10px;
      right: auto;
    }
  }

  video {
    height: 100%;
    width: 100%;
    background-color: #f8f8f8;
    background: transparent;
  }
}
}
`;
export const GreenScreen = styled('div')`
  background: transparent;

  &.left {
    right: auto;
  }

  &.right {
    left: auto;

    .close {
      left: -10px;
      right: auto;
    }
  }

  video {
    height: 100%;
    width: 100%;
    background: transparent;
  }
`;
